module.exports = "<template>${ (!value ? '' : options.prefix + value) | t }</template>";